import { Controller } from "@hotwired/stimulus"

// Flash toast (Ui::FlashComponent, or the same markup built by src/shared/components/flash-messages.js):
// slides in, closes itself after `duration`, and pauses — countdown bar included — while hovered or focused.
const EXIT_MS = 400

export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect () {
    this.remaining = this.durationValue
    this.element.style.setProperty("--flash-message-duration", `${this.durationValue}ms`)

    requestAnimationFrame(() => {
      this.element.classList.add("show")
      this.unfreeze()
    })
  }

  disconnect () {
    clearTimeout(this.timeout)
  }

  freeze () {
    if (!this.timeout) return

    clearTimeout(this.timeout)
    this.timeout = null
    this.remaining -= Date.now() - this.startedAt
    this.element.classList.add("is-paused")
  }

  unfreeze () {
    if (this.timeout || this.element.contains(document.activeElement)) return

    this.startedAt = Date.now()
    this.timeout = setTimeout(() => this.close(), Math.max(this.remaining, 0))
    this.element.classList.remove("is-paused")
  }

  close () {
    if (this.element.classList.contains("is-hiding")) return

    clearTimeout(this.timeout)
    this.element.classList.remove("show")
    this.element.classList.add("is-hiding")

    const removeElement = () => this.element.remove()

    this.element.addEventListener("transitionend", (event) => {
      if (event.target === this.element) removeElement()
    })
    window.setTimeout(removeElement, EXIT_MS + 50)
  }
}
